<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>库存管控</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-row>
            <el-col :span="24">
              <span style="margin:0;">按</span>
              <span style="color:#FF8100;margin:0;">现存量</span>
              <span>管控</span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px">
            <el-col :span="24">
              <el-form-item prop="standingStock">
                <el-radio-group v-model="data.standingStock">
                  <el-radio label="0">按单据</el-radio>
                  <el-radio label="1">按明细</el-radio>
                  <el-radio label="2">按余额</el-radio>
                </el-radio-group>
              </el-form-item>
              <span>（选择严格管控，则录入出库单时，如果现存量不足，无法保存）</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span style="margin:0;">按</span>
              <span style="color:#FF8100;margin:0;">可用量</span>
              <span>管控</span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px">
            <el-col :span="24">
              <el-form-item prop="available">
                <el-radio-group v-model="data.available">
                  <el-radio label="0">按单据</el-radio>
                  <el-radio label="1">按明细</el-radio>
                  <el-radio label="2">按余额</el-radio>
                </el-radio-group>
              </el-form-item>
              <span>（选择严格管控，则录入出库单时，如果可用量不足，无法保存）</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span style="color:#FF8100">可用量=先存量+预计入库量-预计出库量</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="24">
                  <span style="color:#FF8100;margin-right:60px;">预计入库量</span>
                  <el-form-item>
                    <el-checkbox-group v-model="data.expectIn">
                      <el-checkbox label="0">采购在途量</el-checkbox>
                      <el-checkbox label="1">进货待入量</el-checkbox>
                      <el-checkbox label="2">调拨在途量</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span style="color:#FF8100;margin-right:60px;">预计出库量</span>
                  <el-form-item>
                    <el-checkbox-group v-model="data.expectOut">
                      <el-checkbox label="0">销售订单预留</el-checkbox>
                      <el-checkbox label="1">销售待发量</el-checkbox>
                      <el-checkbox label="2">调拨待发量</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>确认销售出库环节</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="outSession">
            <el-radio-group v-model="data.outSession">
              <el-radio label="0">业务员录入并审核销货单后，即扣减现存量</el-radio>
              <el-radio label="1">仓库发货出库后，由仓管员确认后即扣减现存量</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>批次管理</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="batch">
            <el-checkbox v-model="data.batch">启用批次</el-checkbox>
          </el-form-item>
          <span>（启用后，有启动批次管理的商品，在进货和销售的相关单据可填写批次信息）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>保质期管理</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="shelfLife">
            <el-checkbox v-model="data.shelfLife">启用保质期</el-checkbox>
          </el-form-item>
          <span>（启用后，销售的相关单据和库存商品，会进行保质期的提醒和预警）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>成本取价</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-row>
            <el-col :span="24">
              <span>入库成本取价</span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:10px">
            <el-col :span="24">
              <el-form-item prop="inCost">
                <el-radio-group v-model="data.inCost">
                  <el-radio label="0">上次入库成本</el-radio>
                  <el-radio label="1">上次出库成本</el-radio>
                  <el-radio label="2">结存成本</el-radio>
                  <el-radio label="2">参考成本</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span>零成本出库取价</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="outCost">
                <el-radio-group v-model="data.outCost">
                  <el-radio label="0">上次入库成本</el-radio>
                  <el-radio label="1">上次出库成本</el-radio>
                  <el-radio label="2">参考成本</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>商品出库规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="outRules">
            <el-radio-group v-model="data.outRules">
              <el-radio label="0">先进先出</el-radio>
              <el-radio label="1">按保质期</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-alert title="数据保存成功后，需要重新登录才能生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        standingStockId: 0,
        standingStock: null, //按现存量管控
        availableId: 0,
        available: null, //按可用量管控
        expectInId: 0,
        expectIn: [], //预计入库量
        expectOutId: 0,
        expectOut: [], //预计出库量
        outSessionId: 0,
        outSession: null, //确认销售出库环节
        batchId: 0,
        batch: null, //批次管理
        shelfLifeId: 0,
        shelfLife: null, //保质期管理
        inCostId: 0,
        inCost: null, //入库成本取价
        outCostId: 0,
        outCost: null, //零成本出库取价
        outRulesId: 0,
        outRules: null, //商品出库规则
      },
      isNull: false,
      saveData: [],
      formRules: {
        standingStock: [{ required: true, message: "请选择" }],
        available: [{ required: true, message: "请选择" }],
        expectIn: [{ required: true, message: "请选择" }],
        expectOut: [{ required: true, message: "请选择" }],
        outSession: [{ required: true, message: "请选择" }],
        batch: [{ required: true, message: "请选择" }],
        shelfLife: [{ required: true, message: "请选择" }],
        inCost: [{ required: true, message: "请选择" }],
        outCost: [{ required: true, message: "请选择" }],
        outRules: [{ required: true, message: "请选择" }],
      },
      api: require("@/api/sy/opt").default,
    };
  },
  methods: {
    getData() {
      this.api.list({ Code: "STOCK" }).then((res) => {
        
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "StandingStock":
              this.data.standingStockId = item.OptId;
              this.data.standingStock = item.OptValue;
              break;
            case "Available":
              this.data.availableId = item.OptId;
              this.data.available = item.OptValue;
              break;
            case "ExpectIn":
              this.data.expectInId = item.OptId;
              this.data.expectIn = item.OptValue.split(",");
              break;
            case "ExpectOut":
              this.data.expectOutId = item.OptId;
              this.data.expectOut = item.OptValue.split(",");
              break;
            case "OutSession":
              this.data.outSessionId = item.OptId;
              this.data.outSession = item.OptValue;
              break;
            case "Batch":
              this.data.batchId = item.OptId;
              this.data.batch = item.OptValue == "true";
              break;
            case "ShelfLife":
              this.data.shelfLifeId = item.OptId;
              this.data.shelfLife = item.OptValue == "true";
              break;
            case "InCost":
              this.data.inCostId = item.OptId;
              this.data.inCost = item.OptValue;
              break;
            case "OutCost":
              this.data.outCostId = item.OptId;
              this.data.outCost = item.OptValue;
              break;
            case "OutRules":
              this.data.outRulesId = item.OptId;
              this.data.outRules = item.OptValue;
              break;
          }
        });
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [];

        this.saveData.push({
          OptId: this.data.standingStockId,
          Code: "STOCK",
          OptValue: this.data.standingStock,
          OptText: "StandingStock",
        });
        this.saveData.push({
          OptId: this.data.availableId,
          Code: "STOCK",
          OptValue: this.data.available,
          OptText: "Available",
        });
        this.saveData.push({
          OptId: this.data.expectInId,
          Code: "STOCK",
          OptValue: this.data.expectIn.join(),
          OptText: "ExpectIn",
        });
        this.saveData.push({
          OptId: this.data.expectOutId,
          Code: "STOCK",
          OptValue: this.data.expectOut.join(),
          OptText: "ExpectOut",
        });
        this.saveData.push({
          OptId: this.data.batchId,
          Code: "STOCK",
          OptValue: this.data.batch,
          OptText: "Batch",
        });
        this.saveData.push({
          OptId: this.data.outSessionId,
          Code: "STOCK",
          OptValue: this.data.outSession,
          OptText: "OutSession",
        });
        this.saveData.push({
          OptId: this.data.shelfLifeId,
          Code: "STOCK",
          OptValue: this.data.shelfLife,
          OptText: "ShelfLife",
        });
        this.saveData.push({
          OptId: this.data.inCostId,
          Code: "STOCK",
          OptValue: this.data.inCost,
          OptText: "InCost",
        });
        this.saveData.push({
          OptId: this.data.outCostId,
          Code: "STOCK",
          OptValue: this.data.outCost,
          OptText: "OutCost",
        });
        this.saveData.push({
          OptId: this.data.outRulesId,
          Code: "STOCK",
          OptValue: this.data.outRules,
          OptText: "OutRules",
        });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 40px;
  float: left;
}
</style>